import React from "react";

import svg from "../../assets/images/icons/const.svg";

export const ConstantIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Constant"}
    />
);
